import { render, staticRenderFns } from "./BaseBlockComponent.vue?vue&type=template&id=3a464d8b&"
import script from "./BaseBlockComponent.vue?vue&type=script&lang=js&"
export * from "./BaseBlockComponent.vue?vue&type=script&lang=js&"
import style0 from "./BaseBlockComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports